if (!customElements.get('rewards-points')) {
  customElements.define('rewards-points', class RewardsPoints extends HTMLElement {
    connectedCallback() {
      this.desktopEl = this.querySelector('.rewards-points__desktop');
      this.mobileEl = this.querySelector('.rewards-points__mobile');
      this.render(Number(this.dataset.price));
      this.section = this.closest('.js-product');
      if (this.section) {
        this.section.addEventListener('on:variant:change', this.handleVariantChange.bind(this));
      }
    }

    render(price) {
      const rewards = ((price / 100) * 0.02).toFixed(2);
      const value = rewards;
      if (this.desktopEl) {
        this.desktopEl.textContent = this.dataset.desktopText.replace('{value}', value);
      }
      if (this.mobileEl) {
        this.mobileEl.textContent = this.dataset.mobileText.replace('{value}', value);
      }
    }

    handleVariantChange(evt) {
      if (!evt.detail.variant) return;
      this.render(evt.detail.variant.price);
    }
  });
}
